<template>
    <div>
        <template v-if="currentDamSelectedId">
            <ProfileContainer/>
            <CarouselGalleryZoomer/>
        </template>
        <div class="d-flex justify-content-center align-items-center" v-else>
            <b-spinner class="m-5" variant="primary"></b-spinner>
        </div>
    </div>
</template>

<script>
    // mixins
    import getDamDataMixin from "../mixins/getDamDataMixin";
    // utils
    import {setDocumentTitle} from "../utils/i18n/document";
    // components
    import ProfileContainer from "../components/profile/ProfileContainer";
    import CarouselGalleryZoomer from "../components/shared/CarouselGalleryZoomer";

    export default {
        name: 'ProfileView',
        mixins: [getDamDataMixin],
        components: {
            ProfileContainer,
            CarouselGalleryZoomer
        },
        async mounted() {
            setDocumentTitle(this.$t("dam-profile.title"));
        }
    }
</script>

<style>
</style>